import { getJumpBackInCarousels } from './get-jump-back-in-carousels';
import { getRecentDownloadsCarousels } from './get-recent-downloads-carousels';

export const getHomepageCarousels = async (userId?: number) => {
  const [basedOnRecentDlCarousels, jumpBackInCarousels] = await Promise.all([
    getRecentDownloadsCarousels(userId),
    getJumpBackInCarousels(userId),
  ]);

  return {
    basedOnRecentDl: basedOnRecentDlCarousels,
    jumpBackIn: jumpBackInCarousels,
  };
};
